import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailSynopsisArrowRightContainer = styled.div<React.CSSProperties>`
  cursor: pointer;
  position: fixed;
  left: ${1030 * Screen.widthRatio}px;
  top: ${858 * Screen.widthRatio}px;
`;

export default DetailSynopsisArrowRightContainer;
